import axios from "axios";

// AI service runs separately from Licensing.Admin.Api.
// Default port matches Licensing.AI.Api Kestrel default; override below for non-local envs.
//http://localhost:5050/
let baseUrl = "https://licensingaiapi2.azurewebsites.net/";



export const POST_AI_ASK = baseUrl + "api/chat/ask";
export const POST_AI_ANALYTICS = baseUrl + "api/analytics/query";

export async function askAi(question) {
  const { data } = await axios.post(POST_AI_ASK, { question });
  return data; // { answer, toolResults: [{ tool, args, result }, ...] }
}

// Direct aggregate query — bypasses the LLM. Cheap, deterministic, used by the
// Analytics tab charts. Pass any subset of {startDate, endDate, hoursBack,
// licenseType, productFamily, country, status, groupBy}.
export async function fetchAnalytics(params) {
  const { data } = await axios.post(POST_AI_ANALYTICS, params || {});
  return data; // { startDate, endDate, groupBy, total, breakdown: [{ groupKey, count }] }
}
